export const ProjectID = "DSFGStudio";
export const ProjectName = "对话模版编辑器";

export const DialogueEditorID = "DialogueEditor";
export const DialogueEntry = "[DSFG]对话入口";
